import { useTranslation } from "react-i18next";
import "flag-icons/css/flag-icons.min.css";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith("pt") ? "pt" : "en";

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div
      className="language-switcher"
      style={{
        display: "flex",
        gap: "12px",
        alignItems: "center",
        marginLeft: "16px",
      }}
    >
      <span
        className={`fi fi-br ${current === "pt" ? "active-flag" : ""}`}
        role="button"
        tabIndex={0}
        aria-label="Português"
        style={{ cursor: "pointer", fontSize: "24px", borderRadius: "5px" }}
        onClick={() => changeLang("pt")}
        onKeyDown={(event) => event.key === "Enter" && changeLang("pt")}
      />
      <span
        className={`fi fi-us ${current === "en" ? "active-flag" : ""}`}
        role="button"
        tabIndex={0}
        aria-label="English"
        style={{ cursor: "pointer", fontSize: "24px", borderRadius: "5px" }}
        onClick={() => changeLang("en")}
        onKeyDown={(event) => event.key === "Enter" && changeLang("en")}
      />
    </div>
  );
}
